<div class="mb-5" data-testid="home-page">
    @if (loadingCustomerDetails()) {
        <div class="mt-4 mb-3">
            <app-loading-indicator [size]="'large'" [color]="'secondary'"></app-loading-indicator>
        </div>
    }

    <!-- Charts and default content -->
    @if (onboardingComplete() && !loadingCustomerDetails()) {
        <div class="inner-container">
            <div class="box-wrapper">
                <div class="d-flex title-container" style="width: 100%">
                    <div class="title-box col-8 d-flex justify-content-between">
                        <div class="col-9 d-flex" style="gap: 0.25rem; align-items: center">
                            <p class="overflow">
                                @if (companyName && companyName !== "match_name_relationships") {
                                    {{ "overview.owner" | translate }}:
                                    {{ companyName }}
                                } @else {
                                    {{ "overview.owner" | translate }}: {{ persons.representative.first_name }}
                                    {{ persons.representative.last_name }}
                                }
                            </p>

                            @switch (onboardingState().account_state) {
                                @case ("complete") {
                                    <img style="width: 18px; height: 18px" src="assets/icons/onboard/onboard-complete.svg" alt="{{ 'overview.verified' | translate }}" />
                                }
                                @case ("pending") {
                                    <div class="account-state pending">
                                        <img src="assets/icons/onboard/onboard-pending.svg" alt="{{ 'customers.pending' | translate }}" />
                                        <p>{{ "overview.pending_verification" | translate }}</p>
                                    </div>
                                }
                                @case ("restricted") {
                                    <img style="height: 18px; width: 18px" src="assets/icons/onboard/onboard-restricted.svg" alt="{{ 'customers.restricted' | translate }}" />
                                }
                                @case ("restricted_soon") {
                                    <div class="account-state restricted-soon">
                                        <img src="assets/icons/onboard/onboard-restricted_soon.svg" alt="{{ 'customers.restricted_soon' | translate }}" />
                                        <p>{{ "overview.restricted_soon" | translate }}</p>
                                    </div>
                                }
                            }
                        </div>
                        @if (authService.hasLimitedAccess("edit_kyc", authService.getRole())) {
                            <u (click)="goToStripeKYC()" (keyup.enter)="goToStripeKYC()" tabindex="0" data-testid="home-page-edit-kyc-link">
                                <div class="d-flex align-items-center justify-content-center">
                                    @if (!showSmallLoadingIndicator()) {
                                        <p class="my-0" style="font-size: 14px; cursor: pointer">{{ "account.edit" | translate }}</p>
                                    }
                                    @if (showSmallLoadingIndicator()) {
                                        <app-loading-indicator [size]="'tiny'" [color]="'secondary'"></app-loading-indicator>
                                    }
                                </div>
                            </u>
                        }
                    </div>
                    @if (!sidebarService.isBelowMobileWidth()) {
                        <div class="line-chart-btns-wrapper col-4">
                            <button [className]="viewOptionForCharts === 'week' ? 'line-chart-btn active' : 'line-chart-btn inactive'" (click)="week()" data-testid="home-page-chart-range-week-button">
                                {{ "overview.seven_days" | translate }}
                            </button>
                            <button [className]="viewOptionForCharts === 'month' ? 'line-chart-btn active' : 'line-chart-btn inactive'" (click)="month()" data-testid="home-page-chart-range-month-button">
                                {{ "overview.thrity_days" | translate }}
                            </button>
                            <button [className]="viewOptionForCharts === 'year' ? 'line-chart-btn active' : 'line-chart-btn inactive'" (click)="year()" data-testid="home-page-chart-range-year-button">
                                {{ "overview.twelve_months" | translate }}
                            </button>
                        </div>
                    }
                    @if (sidebarService.isBelowMobileWidth()) {
                        <div>
                            <select class="form-select" #selectedFilter (change)="handleDateChange(selectedFilter.value)" data-testid="home-page-chart-range-select">
                                <option value="week">{{ "overview.seven_days" | translate }}</option>
                                <option value="month" [defaultSelected]="true">{{ "overview.thrity_days" | translate }}</option>
                                <option value="year">{{ "overview.twelve_months" | translate }}</option>
                            </select>
                        </div>
                    }
                </div>
            </div>

            <div class="d-flex box outer-box">
                <div class="line-chart-box col-9">
                    <div class="tooltip-box">
                        <div class="tooltip-box">
                            <h4>{{ "overview.revenue" | translate }}</h4>
                            <app-aw-tooltip [tooltipTitle]="'overview.revenue' | translate">
                                <ng-container description>
                                    {{ "overview.follow_revenue" | translate }}
                                </ng-container>
                            </app-aw-tooltip>
                        </div>
                        @if (authService.isOperator()) {
                            <div class="d-flex align-items-center" style="gap: 0.5rem; margin-left: 0.75rem">
                                <app-aw-tooltip [tooltipTitle]="'overview.include_customer_data' | translate">
                                    <div tooltip_element_ref class="include-customer">{{ "overview.include_customer_data" | translate }}</div>
                                    <div description>{{ "overview.include_tooltip_desc" | translate }}</div>
                                </app-aw-tooltip>
                                <app-aw-switch [shouldBeChecked]="showCombined()" (activateClick)="onToggleCombined()" [dataTestId]="'home-page-combine-customer-data-switch'"></app-aw-switch>
                            </div>
                        }
                    </div>

                    <div class="d-flex align-items-center justify-content-center" [style]="sidebarService.isBelowMobileWidth() ? 'min-height: 200px' : 'min-height: 380px'">
                        <div style="width: 100%; height: 100%">
                            <app-line (doneLoading)="updateRevenueOverPeriod($event)"></app-line>
                        </div>
                    </div>
                </div>

                @if (showLoadingIndicatorForPayoutDetails()) {
                    <div clasS="col-3 sidebar d-flex align-items-center justify-content-center">
                        <app-loading-indicator [size]="'large'" [color]="'secondary'"></app-loading-indicator>
                    </div>
                } @else {
                    <div class="col-md-3 sidebar">
                        <!--Total revenue-->
                        <div>
                            <div class="sidebar-flex">
                                <div>{{ "misc.revenue" | translate }}</div>
                                <app-aw-tooltip [tooltipTitle]="'misc.revenue' | translate">
                                    <ng-container description>
                                        <span> {{ "overview.total_revenue" | translate }} </span>
                                    </ng-container>
                                </app-aw-tooltip>
                            </div>
                            <hr />
                            <div class="sidebar-result">
                                <p class="payout-total-revenue">{{ totalRevenue }}</p>
                            </div>
                        </div>

                        <!--Payout-->
                        <div>
                            <div class="sidebar-flex">
                                <div>{{ "overview.avaialbe_funds" | translate }}</div>
                                <app-aw-tooltip class="d-flex" [tooltipTitle]="'overview.avaialbe_funds' | translate">
                                    <ng-container description>
                                        <span> {{ "overview.current_balance_stripe" | translate }} </span>
                                        <br />
                                        @for (ba of availableFunds(); track ba.docId; let i = $index) {
                                            <br />
                                            <span>{{ ba.baName }}</span>
                                            <br />
                                            <span>{{ "overview.amount_available" | translate }}: {{ availableFundsLabels()[i] }}</span>
                                            <br />
                                            <span>{{ "overview.incoming_amount" | translate }}: {{ formatPendingAmount(ba) }}</span>
                                            <br />
                                        }
                                    </ng-container>
                                </app-aw-tooltip>
                            </div>
                            <hr />

                            <div class="sidebar-result">
                                <div class="sidebar-result-flex">
                                    <p [style.font-size]="availableFundsLabels()[0].length > 12 ? '14px' : '16px'">{{ availableFundsLabels()[0] }}</p>
                                    @if ((authService.getRole() === "editor" || authService.getRole() === "owner") && shouldShowQuickPayout()) {
                                        <p [class.locked]="availableFunds().length === 0" (click)="openQuickPayoutModal(quickPayoutModal)" class="sidebar-result-flex-action" data-testid="home-page-quick-payout-open-link">
                                            {{ "overview.payout_now" | translate }}
                                            @if (availableFunds().length !== 0) {
                                                <img src="assets/icons/arrow-right-green.svg" alt="arrow right" />
                                            }
                                        </p>
                                    }
                                </div>
                                <a
                                    class="small-note"
                                    href="https://wiser.airwallet.net/en/article/understanding-your-payout-schedule-and-revenue-collection-cqirg2/?bust=1723034171745"
                                    target="_blank"
                                    data-testid="home-page-payout-schedule-link"
                                >
                                    {{ "overview.explanation" | translate }}
                                </a>
                            </div>
                        </div>

                        <!--Date for renewal-->
                        <div>
                            <div class="sidebar-flex">
                                <div>{{ "overview.date_next_pay" | translate }}</div>
                                <app-aw-tooltip [tooltipTitle]="'overview.date_next_pay' | translate">
                                    <ng-container description>
                                        <span> {{ "overview.est_arrival_date" | translate }} </span>
                                    </ng-container>
                                </app-aw-tooltip>
                            </div>
                            <hr />
                            @if (availableFunds().length > 0) {
                                <div class="sidebar-result">
                                    <p class="payout-date">{{ formatPayoutDate(availableFunds()[0]) }}</p>
                                </div>
                            }
                        </div>

                        <!-- Payout Frequency -->
                        <div>
                            <div class="sidebar-flex">
                                <div>{{ "account.payout.frequency" | translate }}</div>
                            </div>
                            <hr />
                            <div class="sidebar-result">
                                <div class="sidebar-result-flex">
                                    <p class="payout-date">{{ "misc." + fireCustomer().payout_settings.interval | translate }}</p>
                                    @if (shouldShowWeeklyPayoutCTA()) {
                                        <p class="sidebar-result-flex-action" [routerLink]="'/account'" data-testid="home-page-change-to-weekly-payout-link">
                                            {{ "account.payout.change_weekly" | translate }}
                                            <img src="assets/icons/arrow-right-green.svg" alt="arrow right" />
                                        </p>
                                    }
                                </div>
                            </div>
                        </div>

                        <!--Active users-->
                        <div>
                            <div class="sidebar-flex">
                                <div>{{ "overview.active_users" | translate }}</div>
                                <app-aw-tooltip [tooltipTitle]="'overview.active_users' | translate">
                                    <ng-container description>
                                        <span> {{ "overview.amount_of_users" | translate }} </span>
                                    </ng-container>
                                </app-aw-tooltip>
                            </div>
                            <hr />
                            <div class="d-flex justify-content-between">
                                <div class="sidebar-result sidebar-bottom">
                                    <p class="active-users">{{ active_users_present() }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>

            @if (isActionsEnabled()) {
                <div class="box actions-box">
                    <div class="box-header">
                        <div class="box-header-flex">
                            <div class="tooltip-box">
                                <h4>{{ "operator.filter_bar.actions" | translate }}</h4>
                                <app-aw-tooltip [tooltipTitle]="'operator.filter_bar.actions' | translate">
                                    <ng-container description>
                                        <span>{{ "overview.actions_tooltip" | translate }} </span>
                                    </ng-container>
                                </app-aw-tooltip>
                            </div>
                        </div>
                        @if (!sidebarService.isBelowMobileWidth()) {
                            <p class="pointer" [routerLink]="['/actions']" data-testid="home-page-actions-open-list-link">
                                <u>{{ "overview.open_list" | translate }}</u>
                                <img src="assets/icons/arrow-up-blue.svg" style="transform: rotate(90deg)" alt="{{ 'customers.company_name' | translate }}" />
                            </p>
                        }
                    </div>
                    @if (actionLoading()) {
                        <div class="m-5">
                            <app-loading-indicator [size]="'large'" [color]="'secondary'"></app-loading-indicator>
                        </div>
                    }
                    @if (!actionLoading() && !!actions) {
                        <div class="action-grid">
                            @for (action of actions; track action) {
                                <ng-container style="width: 33%">
                                    <app-small-actions-card [action]="action" [isSkeleton()]="isSkeleton()" [isSmallerCard]="true"></app-small-actions-card>
                                </ng-container>
                            }
                        </div>
                    }
                    @if (showNoActionsBox() && !actionLoading()) {
                        <div class="empty-container d-flex align-items-center justify-content-center flex-column">
                            <div class="content-container">
                                <div class="empty-top-half">
                                    <div class="lottie-container">
                                        <ng-lottie [options]="options" class="lottie-waves"></ng-lottie>
                                    </div>
                                    <p>{{ "operator.actions.empty_boxes.no_active_actions_hooray" | translate }}</p>
                                </div>
                                <p>{{ "operator.actions.empty_boxes.no_active_actions" | translate }}</p>
                            </div>
                        </div>
                    }
                    @if (sidebarService.isBelowMobileWidth()) {
                        <p class="pointer bottom-link" [routerLink]="['/actions']" data-testid="home-page-actions-open-list-mobile-link">
                            <u>{{ "overview.open_list" | translate }}</u>
                            <img src="assets/icons/arrow-up-blue.svg" style="transform: rotate(90deg); margin-left: 6px" alt="{{ 'customers.company_name' | translate }}" />
                        </p>
                    }
                </div>
            }

            @if (authService.isOperator()) {
                <div class="contract-container d-flex">
                    <app-contract-performance-list class="col-6 contract-box"></app-contract-performance-list>
                    <app-contract-expiring-list class="col-6 contract-box"></app-contract-expiring-list>
                </div>
            }
        </div>
    } @else if (!loadingCustomerDetails()) {
        <!-- Onboarding flow content -->
        <app-onboarding></app-onboarding>
    }
</div>

<ng-template #quickPayoutModal let-modal>
    <app-instant-payout-modal [availableFunds]="availableFunds()" />
</ng-template>

<ng-template #introductionModal>
    <app-introduction-modal />
</ng-template>

<ng-template #categorizeLocationsModal>
    <app-categorize-locations-modal [locations]="uncategorizedLocations()" />
</ng-template>
